import React, { FC, Fragment } from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { OrderFormRestorationType, RestorationData } from 'models/order-form';
import { convertToSwedishMaterialName } from 'utils/material-enum-to-swedish';
import { formatTeethList, formatTeethRange, isFdiTooth } from 'utils/teeth';

const formatRecognisedRange = (from: string, to: string) =>
    isFdiTooth(from) && isFdiTooth(to) ? formatTeethRange(Number(from), Number(to)) : `${from}-${to}`;

type ConstructionSummaryProps = {
    restorationData: RestorationData[];
};
const ConstructionSummary: FC<ConstructionSummaryProps> = ({ restorationData }: ConstructionSummaryProps) => {
    const { t: translate } = useTranslation(['order-forms']);

    return (
        <Fragment>
            {restorationData.map((restoration) => (
                <Box key={restoration.restorationType} mb={1}>
                    <Box>
                        {restoration.restorationType !== OrderFormRestorationType.UNKNOWN
                            ? translate(`order-forms:${restoration.restorationType}`)
                            : undefined}
                    </Box>
                    {restoration.teeth?.length ? (
                        <Box>
                            {translate('orders:TEETH')}:&nbsp;
                            {formatTeethList(restoration.teeth)}
                        </Box>
                    ) : undefined}
                    {restoration.teethRange?.length ? (
                        <Box>
                            {translate('orders:TEETH')}:&nbsp;
                            {restoration.teethRange.map((range) => (
                                <span key={range.from} style={{ paddingRight: '1em' }}>
                                    {formatRecognisedRange(range.from, range.to)}
                                </span>
                            ))}
                        </Box>
                    ) : undefined}
                    {restoration.jaw && restoration.teeth?.length === 0 && restoration.teethRange?.length === 0 ? (
                        <Box>{translate(`order-forms:${restoration.jaw}`)}</Box>
                    ) : undefined}
                    {restoration.material ? <Box>{convertToSwedishMaterialName(restoration.material)}</Box> : undefined}
                </Box>
            ))}
        </Fragment>
    );
};

export default ConstructionSummary;
